

































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { PaywallPlansInfo, User } from 'frontend/types';
import PaywallPlans from 'frontend/views/premium/PaywallPlans.vue';
import PageContent from 'frontend/views/premium/paywall/PageContent.vue';
import ReferAFriendModal from 'frontend/views/referral/components/ReferAFriendModal.vue';
import NuxPaywall from 'frontend/views/premium/NuxPaywall.vue';
import PaywallFooterCta from 'frontend/views/premium/paywall/PaywallFooterCta.vue';
import PaywallGiftGroups from 'frontend/views/premium/paywall/PaywallGiftGroups.vue';
import { scrollToAnchorName } from 'frontend/utils/scroll';

@Component({
  components: {
    PaywallPlans,
    PageContent,
    ReferAFriendModal,
    NuxPaywall,
    PaywallFooterCta,
    PaywallGiftGroups,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('paywall', ['paywallPlans']),
    ...mapState('globals', ['user']),
    ...mapState('paywall', ['paywall_type']),
    ...mapState('pageHeader', ['context']),
    ...mapState('viewedReferralModal', ['userHasSeenReferralModal']),
  },
  metaInfo: {
    title: 'Brilliant Premium',
  },
})
export default class PremiumPaywall extends Vue {
  private context: any;
  private readonly paywallPlans!: PaywallPlansInfo;
  private user!: User;

  private referAFriendModalDismissed = false;

  private userHasSeenReferralModal!: boolean;
  private processingPayment: boolean = false;

  private get shouldShowTrialPaywall(): boolean {
    // We should only show the trial paywall if the user has a trial
    // available AND is not already a premium user.
    // The processingPayment flag is used to prevent NuxPaywall from
    // being unmounted immediately after the user becomes premium
    return (
      (this.user.has_current_trial_option && !this.user.has_brilliant_premium) ||
      this.processingPayment
    );
  }

  private get showReferAFriendModal(): boolean {
    return (
      this.refereeDiscountAvailable &&
      !this.userHasSeenReferralModal &&
      !this.referAFriendModalDismissed
    );
  }

  private closeReferAFriendModal() {
    this.referAFriendModalDismissed = true;
  }

  private get refereeDiscountAvailable(): boolean {
    return !!this.refereeDiscountData;
  }

  private get refereeDiscountData() {
    return this.context?.referral_context?.referee_discount;
  }

  private get footerCtaText(): string {
    if (!!this.paywallPlans.annualPlan && this.paywallPlans.annualPlan.is_trial) {
      return 'Get 7 days free';
    }
    return 'Subscribe now';
  }

  private footerCtaClicked() {
    scrollToAnchorName('paywall-header');
  }
}
